import { useState, useEffect, RefObject, useCallback } from 'react'

export const isElementInViewport = (el: Element) => {
  const rect = el.getBoundingClientRect()

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

const useInViewPort = (ref: RefObject<Element>, delay = 0) => {
  const [isVisible, setIsVisible] = useState(() =>
    ref?.current ? isElementInViewport(ref.current) : false,
  )

  const update = useCallback(() => {
    setTimeout(() => {
      if (ref.current) {
        setIsVisible(isElementInViewport(ref.current))
      }
    }, delay)
  }, [delay])

  useEffect(() => {
    if (document.readyState === 'complete') {
      update()
    }

    ;[
      'scroll',
      'load',
      'DOMContentLoaded',
      'resize',
      'click',
      'keydown',
    ].forEach((type) => {
      window.addEventListener(type, update)
    })
    return () => {
      ;[
        'scroll',
        'load',
        'DOMContentLoaded',
        'resize',
        'click',
        'keydown',
      ].forEach((type) => {
        window.removeEventListener(type, update)
      })
    }
  }, [update, delay])
  return { isVisible, update }
}

export { useInViewPort }
